// extracted by mini-css-extract-plugin
module.exports = {"container":"TextArea_container__fQkB5","label":"TextArea_label__1aPc6","input":"TextArea_input__3QMzP"};